<template>
  <div class="ai-avatar-cn-page">
    <TopHeader class="landing-container-top" />
    <Page class="page-banner">
      <Banner />
    </Page>
    <Page>
      <ChooseAvatar />
    </Page>
    <Page class="bg-[var(--x-back-3)]">
      <AmazingDetail />
    </Page>
    <Page>
      <CustomizeAvatar />
    </Page>
    <Page class="page-video bg-[var(--x-text-1)]" name="AI Video">
      <VideoFeature />
    </Page>
    <Page>
      <ThousandsAvatars />
    </Page>
    <Page class="bg-[var(--x-back-3)]">
      <Operation @handle-trail="handleTrail" />
    </Page>
    <Page class="bg-[var(--x-back-1)]">
      <Faq />
    </Page>
    <Page>
      <StartRightNow :handler="handleTrail" />
      <Footer />
    </Page>
  </div>
</template>

<script setup lang="ts">
import Operation from '@/design/widgets/product-operation/cn-operation.vue';
import Footer from '~/design/widgets/bottom-footer/footer-cn.vue';
import StartRightNow from '~/design/widgets/start-right-now/index.vue';
import TopHeader from '~/design/widgets/top-header/index.vue';
import Page from './components/page.vue';
import AmazingDetail from './modules/amazing-detail/index.vue';
import Banner from './modules/banner/index.vue';
import ChooseAvatar from './modules/choose-avatar/index.vue';
import CustomizeAvatar from './modules/customize-avatar/index.vue';
import Faq from './modules/faq/index.vue';
import ThousandsAvatars from './modules/thousands-avatars/index.vue';
import VideoFeature from './modules/video-feature/index.vue';

const handleTrail = () => {
  const userInfo = useUserInfo();
  if (!userInfo.value) {
    navigateTo(
      `/login?redirect=${encodeURIComponent(encodeURIComponent(`${location.origin}/workspace`))}`,
    );
  } else {
    location.href = '/workspace';
  }
};
</script>

<style lang="scss" scoped src="./style/mobile.scss" />
<style lang="scss" scoped src="./style/pc.scss" />
